export const filterUnitsByUserUnit = (units, user) => {
	return user.type === 2
		? units.filter((unit) => user.unit_id === unit.id)
		: units;
};
